/**
 * Helpers for redirecting away from an offline request URL once it syncs.
 *
 * An offline-created request lives at `/request-detail?id=o-1001`. When the
 * device reconnects, sync replaces `o-1001` with a real server id, so that URL
 * no longer resolves. This builds the route to redirect to. (#995 multi-rack QA)
 */

export interface RequestIdMapping {
  offlineId: string;
  serverId: string;
}

/**
 * Given the request id currently shown and the offline->server id mappings from
 * a completed sync, return the route to redirect to, or null when no redirect is
 * needed (not an offline id, or this offline id was not part of the sync).
 */
export function buildRemappedRequestRoute(
  currentRequestId: string | null | undefined,
  mappings: RequestIdMapping[] | undefined,
  currentStep?: string,
): string | null {
  if (!currentRequestId || !currentRequestId.startsWith('o-')) {
    return null;
  }
  const mapping = mappings?.find(m => m.offlineId === currentRequestId);
  if (!mapping) {
    return null;
  }
  const stepParam = currentStep ? `&step=${currentStep}` : '';
  return `/request-detail?id=${mapping.serverId}${stepParam}`;
}
